export function findLast<T>(arr: Array<T>, pred: (e: T) => boolean): T | null {
  let i = arr.length - 1;
  for (; i >= 0; i--) {
    if (pred(arr[i])) return arr[i];
  }
  return null;
}
